import React from 'react';
import { useEnsureLatestInitialisedGoogleMapsService } from './useEnsureLatestInitialisedGoogleMapsService';
/** Used as a wrapper for the Google Map API interactions NOT being the googleMapsService.
 *  e.g. (Unstyled)Map, Marker, using `google.maps.bounds`. Returns null, or your own loader if passed,
 *  if sdk is not ready/initialised. s*/
export var EnsureLatestGoogleMapsSdk = function (_a) {
    var children = _a.children, _b = _a.loader, loader = _b === void 0 ? false : _b;
    var sdkReady = useEnsureLatestInitialisedGoogleMapsService();
    if (!sdkReady) {
        if (loader === false) {
            return null;
        }
        return React.createElement(React.Fragment, null, loader === true ? _Loader : loader);
    }
    return React.createElement(React.Fragment, null, children);
};
// todo make fancy when we have one.
var _Loader = React.createElement("div", null, "Loading");
//# sourceMappingURL=EnsureLatestGoogleMapsSdk.js.map